if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 768px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });

        // Select the arrows inside the thumbnail slider
        const prevButton = this.elements.thumbnails.querySelector('.slider-button--prev');
        const nextButton = this.elements.thumbnails.querySelector('.slider-button--next');

        // Add click listeners to them
        if (prevButton) prevButton.addEventListener('click', this.arrowClick.bind(this, 'prev'));
        if (nextButton) nextButton.addEventListener('click', this.arrowClick.bind(this, 'next'));

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      // onSlideChanged(event) {
      //   if (event.detail && event.detail.currentElement) {
      //     const currentElement = event.detail.currentElement;
      //     if (currentElement.dataset && currentElement.dataset.mediaId) {
      //       const thumbnail = this.elements.thumbnails.querySelector(
      //         `[data-target="${currentElement.dataset.mediaId}"]`
      //       );
      //       this.setActiveThumbnail(thumbnail);
      //     }
      //   }
      // }
      onSlideChanged(event) {
        if (event.detail && event.detail.currentElement) {
          const currentElement = event.detail.currentElement;
          if (currentElement.dataset && currentElement.dataset.mediaId) {
            // Prevent resetting to the first image if a variant was selected
            if (this.elements.viewer.dataset.selectedMediaId && 
                this.elements.viewer.dataset.selectedMediaId !== currentElement.dataset.mediaId) {
                return;
            }
            const thumbnail = this.elements.thumbnails.querySelector(
                `[data-target="${currentElement.dataset.mediaId}"]`
            );
            this.setActiveThumbnail(thumbnail);
          }
        }
      }

      arrowClick(direction) {
        // 1. Get the currently active thumbnail
        const currentId = this.elements.viewer.dataset.selectedMediaId;
        console.log(currentId)

        // If nothing is selected yet, default to the first one
        let currentThumb;
        if (currentId) {
          currentThumb = this.elements.thumbnails.querySelector(`[data-target="${currentId}"]`);
        } else {
          currentThumb = this.elements.thumbnails.querySelector('li');
        }

        if (!currentThumb) return;

        // 2. Find the next or previous sibling <li>
        let targetThumb;
        if (direction === 'next') {
          targetThumb = currentThumb.nextElementSibling;
        } else {
          targetThumb = currentThumb.previousElementSibling;
        }

        // 3. If a sibling exists, click it!
        if (targetThumb) {
          this.setActiveMedia(targetThumb.dataset.target);
        }
      }
      
      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
        }
        this.elements.viewer.dataset.selectedMediaId = mediaId;
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        /* Disabled to always scroll the thumbnail slider on image gallery on product page

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.setSlidePosition(thumbnail[this.elements.thumbnails.offsetLeft]);

        */
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
